const TableConstants = {
    Select: 'select',
    Visibility: 'visibility',
    Actions: 'actions',
    Expand: 'expand',
    ColumnOffsetPropertyPrefix: '--column-header-offset-width',
};

const TableIgnoredColumns = [
    TableConstants.Visibility,
    TableConstants.Actions,
    TableConstants.Select,
    TableConstants.Expand,
];

export { TableConstants, TableIgnoredColumns };
